class Wait {
  constructor() {
    this.promise = undefined;
    this.timeoutId = undefined;
    this.startTime = undefined;

    this.wait = ({ name, timeoutSeconds = 60 }) => {
      return new Promise((resolve) => {
        this.promise = { resolve };

        const check = () => {
          if (window[name]) {
            resolve();
            return;
          }

          const difference = new Date().getTime() - this.startTime;
          if (difference < timeoutSeconds * 1000) {
            this.timeoutId = setTimeout(() => check(), 100);
          } else {
            this.abort();
          }
        };

        this.startTime = new Date().getTime();
        check();
      });
    };

    this.abort = () => {
      if (this.timeoutId && this.promise) {
        this.promise.resolve('ABORT');
        clearTimeout(this.timeoutId);
      }
    };
  }
}

export default new Wait();
